import { useTranslation } from 'react-i18next';

function ManualReceiptInput(props) {
    const { t } = useTranslation();

    const { register, formState } = props;

    return (
        <div className='pweu-manual-receipt-input'>
            <div>
                <label htmlFor="receiptNumber">{t("Receipt number")}*</label>
                <input type="text" placeholder={t("Receipt number")} name="receipt_number" id='receiptNumber' {...register("receipt_number", { required: true, validate: (value) => { return !!value.trim() } })} />
                {(formState.errors.receipt_number?.type === "required" || formState.errors.receipt_number?.type === "validate") && (
                    <span className="error" >{t("Please fill in the Receipt Number")}</span>
                )}
            </div>
            <div>
                <label htmlFor="storeVATNr">{t("Store VAT number")}*</label>
                <input type="text" placeholder={t("Store VAT number")} name="store_vat_nr" id='storeVATNr' {...register("store_vat_nr", {
                    required: true, pattern: {
                        value: /^[0-9]{10}$/,
                    }
                })} />
                {formState.errors.store_vat_nr && <span className="error">{t("Please fill in the VAT number")}</span>}
            </div>
        </div>
    );
}

export default ManualReceiptInput;
